<mat-form-field>
  <mat-label>{{label}}</mat-label>
  <mat-chip-grid [disabled]="disabled" #chipList aria-label="Chips">
    @for (chip of chips; track chip) {
      <mat-chip-row
        (removed)="remove(chip)">
        {{chip}}
        @if (removable) {
          <mat-icon matChipRemove>cancel</mat-icon>
        }
      </mat-chip-row>
    }
    <input
      placeholder="New..."
      #chipInput
      [formControl]="chipCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="add($event)">
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (chip of filteredChips | async; track chip) {
      <mat-option [value]="chip">
        {{chip}}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>